import { render, staticRenderFns } from "./NewTransfers.vue?vue&type=template&id=04350e24"
import script from "./NewTransfers.vue?vue&type=script&lang=js"
export * from "./NewTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports